module.exports = __webpack_public_path__ + "img/elec_dianchi_info.f6178564.png";